import React from "react";
import { observer } from "mobx-react-lite";
import { FONT_COLOR } from "../../../../../components/fonts/font-props";
import FontBody1 from "../../../../../components/fonts/font-body1/font-body1";
import migrateGlobalEMerchantsPageStore from "../../stores/migrate-global-e-merchants-page-store";
import "../../migrate-global-e-merchants.scss";

const MigrateGlobalEMerchantsResult: React.FC = observer(() => {
    const submittedRequest = migrateGlobalEMerchantsPageStore.getSubmittedRequest();
    const error = migrateGlobalEMerchantsPageStore.getStartMigrationRequestError();
    const email = migrateGlobalEMerchantsPageStore.getAdminUserEmail();

    return (
        <>
            {submittedRequest && (
                <div className="results-message">
                    <FontBody1 color={FONT_COLOR.SEMANTIC_SUCCESS}>
                        Migration has been successfully started on the server. It will take some time to complete. You will receive the results on your email: {email}
                        <br /><br />
                        <strong>Environment:</strong> {submittedRequest.environment}
                        <br />
                        <strong>Merchant IDs ({submittedRequest.merchantIds.length}):</strong> {submittedRequest.merchantIds.join(", ")}
                    </FontBody1>
                </div>
            )}

            {!!error && (
                <div className="results-message">
                    <FontBody1 color={FONT_COLOR.SEMANTIC_DANGER}>
                        Migration has not started because of error: {error}. Please try again.
                    </FontBody1>
                </div>
            )}
        </>
    );
});

export default MigrateGlobalEMerchantsResult;
